import { useEffect, useState } from "react"
import { getUsosLote } from "api/agro"
import { getErrorMessage } from "helpers/error_helpers"

/**
 * BDSJEA-409: catálogo de uso de lote / destino (TABLASGENERALES 146).
 *
 * Fuente única (backend ewan-agro, GET /api/agro/dominios/uso-lote) para el
 * combo de destino del establecimiento y el de uso del lote. Se consulta al
 * montar la pantalla (sin caché de módulo: el backend ya cachea 60 s), así
 * que un ítem nuevo del catálogo aparece al reabrir la pantalla.
 *
 * @returns {{ usos: Array<{value: string, label: string}>, cargando: boolean, error: (string|null) }}
 */
export const useUsosLote = () => {
  const [estado, setEstado] = useState({
    usos: [],
    cargando: true,
    error: null,
  })

  useEffect(() => {
    let activo = true
    Promise.resolve()
      .then(() => getUsosLote())
      .then(items => {
        if (!activo) return
        const usos = (Array.isArray(items) ? items : [])
          .filter(i => i && i.codigo)
          .map(i => ({ value: i.codigo, label: i.descripcion || i.codigo }))
        setEstado({ usos, cargando: false, error: null })
      })
      .catch(err => {
        if (!activo) return
        setEstado({
          usos: [],
          cargando: false,
          error: getErrorMessage(err),
        })
      })
    return () => {
      activo = false
    }
  }, [])

  return estado
}

export default useUsosLote
